import React from 'react';
import { Typography, Box, Card} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import PendingDriver from '../../components/Datatable/PendingDriver'
import { Pending } from '@mui/icons-material';



const PendingDriverAllocation = () => {
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));
  const breadcrumbs = [
    <Link underline="hover" key="1" style={{ textDecoration: 'none' ,color:'#3c7f06'}} to={'/dashboard'}>
      Dashboard
    </Link>,
    <Typography key="3" sx={{ color: '#99abb4' }}>
      Orders
    </Typography>,
  ];
  return (
    <Box className="categories-con-cls">
      <DrawerHeader />
      <Card sx={{ display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "start", sm: "center" },
        gap:1,
        flexWrap:'wrap',
        justifyContent: "space-between", p:  { xs: "20px", sm: "20px 40px" }, boxShadow: '1px 0 5px rgba(0, 0, 0, 0.1)' }}>
        <Typography variant="body1" sx={{ mb: 0, color: '#000', fontWeight: 600, fontSize: "22px" }}>
        Orders
        </Typography>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
      </Card>

      <Box sx={{p:3}}>
      <Card sx={{ mt: "20px", p: "0", boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.05)' }}>
            <Box sx={{ p: 2 }}>
              <PendingDriver />
            </Box>
          </Card>
          </Box>
    </Box>
  );
};

export default PendingDriverAllocation;
